<kendo-formfield>
    <kendo-label [text]="caption | translate" for="usersList">
    </kendo-label>
    <kendo-combobox #usersList [ngClass]="{'fx-fill': settings.fxFill}" [data]="usersList$ | async"
        [textField]="'userName'" [valueField]="'id'" [valuePrimitive]="true" [formControl]="control"
        [filterable]="true" [kendoDropDownFilter]="filterSettings" (valueChange)="onChange($event)">
        <ng-template kendoComboBoxItemTemplate let-user>

            <div fxFill fxLayout="row" class="user">         
                <div fxLayout="column" class="user-details">
                    <div class="user-name">
                        <kendo-icon *ngIf="!user.isEnabled" name="cancel" themeColor="error" size="large"></kendo-icon>
                        {{ user.name }} - {{ user.surname }}
                    </div>
                    <div class="user-username">{{ user.userName }}</div>
                </div>
            </div>
        </ng-template>
    </kendo-combobox>
</kendo-formfield>